import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { map, catchError, of } from 'rxjs';

export const publicGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkAuthStatus().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        return true;
      }
      router.navigate(['/dashboard']);
      return false;
    }),
    catchError((error) => {
      console.error('Error in publicGuard:', error);
      // Si hay error, permitimos acceso a la página pública
      return of(true);
    }),
  );
};
